export interface User {
  id?: number;
  username: string;
  password?: string; 
  version?: number;
  device_token?: string;
  customer_id?: number;
  created_on?: Date;
  created_by?: number;
}

export interface UserDetails {
  user_id?: number;
  name: string;
  email?: string;
  mobile?: string;
  emp_code?: string;
  image?: string;
  base_location?: string;
  version?: number;
}

export interface Role {
  id?: number;
  name: string;
  version?: number;
  created_on?: Date;
}

export interface UserFormData {
  id?: number;
  username: string;
  password?: string;
  confirmPassword?: string;
  userDetails: UserDetails;
  roleIds: number[];
  roleNames: string[];
  regionIds: (number | string)[]; // Support both numeric (database) and string (temporary) region IDs
  regionNames: string[];
  siteIds: (number | string)[]; // Support both numeric (database) and string (temporary) site IDs
  siteNames: string[];
  userType: 'admin' | 'operator';
  isNew?: boolean;
  hasUnsavedChanges?: boolean;
}

export interface UserWithRelations {
  user: User;
  userDetails: UserDetails;
  roles: Role[];
  regions: any[]; 
  sites: any[]; 
}

export interface UserCreateRequest {
  user: {
    username: string;
    password?: string;
    version?: number;
    device_token?: string;
    customer_id?: number;
  };
  userDetails: {
    name: string;
    email?: string;
    mobile?: string;
    emp_code?: string;
    image?: string;
    base_location?: string;
    version?: number;
  };
  roleIds: number[];
  regionIds: (number | string)[]; // Support both numeric (database) and string (temporary) region IDs
  siteIds: (number | string)[]; // Support both numeric (database) and string (temporary) site IDs
}

export interface UserUpdateRequest {
  id: number;
  user?: Partial<User>;
  userDetails?: Partial<UserDetails>;
  roleIds?: number[];
  regionIds?: (number | string)[]; // Support both numeric (database) and string (temporary) region IDs
  siteIds?: (number | string)[]; // Support both numeric (database) and string (temporary) site IDs
}

export interface UserResponse {
  user: User;
  userDetails: UserDetails;
  roles: Role[];
  regions: any[]; 
  sites: any[]; 
}

export enum UserType {
  ADMIN = 'admin',
  OPERATOR = 'operator'
}

export enum RoleName {
  ADMIN = 'admin',
  USER = 'user' 
}
